import { useQuery } from "react-query";
import QUERY_KEYS from "../queryKeys";
import {
  getTeamDetails,
  getTeamHighlights,
  getTeamPosts,
} from "./queryFunctions";
import commonConfig from "../config";

export const useTeamProfile = (team_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.TEAM_DETAILS, team_id],
    queryFn: () => getTeamDetails({ team_id }),
    ...commonConfig,
    ...config,
  });

export const useTeamHighlights = (
  page,
  limit,
  geo_lat,
  geo_long,
  team_id,
  config = {}
) =>
  useQuery({
    queryKey: [
      QUERY_KEYS.TEAM_HIGHLIGHTS,
      page,
      limit,
      geo_lat,
      geo_long,
      team_id,
    ],
    queryFn: () =>
      getTeamHighlights({ page, limit, geo_lat, geo_long, team_id }),
    ...commonConfig,
    ...config,
  });

export const useTeamPosts = (
  page,
  limit,
  geo_lat,
  geo_long,
  team_id,
  config = {}
) =>
  useQuery({
    queryKey: [QUERY_KEYS.TEAM_POSTS, page, limit, geo_lat, geo_long, team_id],
    queryFn: () => getTeamPosts({ page, limit, geo_lat, geo_long, team_id }),
    ...commonConfig,
    ...config,
  });
